<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/team")
          i.fa.fa-trophy
          span.ml-1 {{ $tc("ui.teams", 1) }}
      b-breadcrumb-item
        router-link(to="/team/remapteam")
          i.fas.fa-link
          span.ml-1 {{ $t("ui.remap_team") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="teamSearch" :placeholder="$t('message.search_by_team_name')")
                div.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $t("ui.id") }}
                    b-form-radio(value="name") {{ $t("ui.name") }}
          div.row
            div.col-md-12.mb-1
              div.form-row
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="team_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="team_name") {{ $tc("ui.teams", 1) }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1
                  div.form-check.form-check-inline
                    b-form-checkbox(v-model="filter").mr-3
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.filter") }}
                    b-form-checkbox(v-model="linked" v-if="filter").mr-3
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.linked") }}
                    b-form-checkbox(v-model="fetched" v-if="filter").mr-3
                      div(style="color:rgba(0, 0, 0, 0.5)") {{ $t("ui.fetched") }}
                div.col-md-4.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLinkedTeamList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.sbo_self_map')"
                    type="button"
                    @click="remapTeam('first', 'self')"
                    variant="primary"
                    size="sm"
                    v-if="sboTeamInfo && ibcTeamInfo"
                    ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.ibc_self_map')"
                    type="button"
                    @click="remapTeam('second', 'self')"
                    variant="primary"
                    size="sm"
                    v-if="sboTeamInfo && ibcTeamInfo"
                    ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.sbo_prefer')"
                    type="button"
                    @click="remapTeam('first', 'prefer')"
                    variant="secondary"
                    size="sm"
                    v-if="unteamIdSelected !=''"
                  ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-link"
                    :text="$t('ui.ibc_prefer')"
                    type="button"
                    @click="remapTeam('second', 'prefer')"
                    variant="secondary"
                    size="sm"
                    v-if="unteamIdSelected !=''"
                  ).mr-2
        div.card-body
          div(v-if="pageLvl == 'master'")
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="teamTotalRow"
                  :per-page="getPageSize"
                  v-model="currentTeamPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="teamTotalRow" readonly)
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(width=100 @click="sortOrder('team_id', 'master')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('team_id', 'master')")
                        th.sticky-position(width=80 @click="sortOrder('sport_type', 'master')")
                          span {{ $tc('ui.sports', 1) }}
                          i(:class="changeSortKey('sport_type', 'master')")
                        th.sticky-position(@click="sortOrder('team_name', 'master')")
                          span {{ $t("ui.name") }}
                          i(:class="changeSortKey('team_name', 'master')")
                        th.sticky-position(width=100)
                          span {{ $t("ui.sbo") }}
                        th.sticky-position(width=100)
                          span {{ $t("ui.ibc") }}
                        th.sticky-position(width=100)
                          span {{ $t("ui.prefer") }}
                        th.sticky-position(width=60)
                          span {{ $t("ui.linked") }}
                        th.sticky-position(width=40).text-center
                          span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                        th.text-center.sticky-position(width=100)
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="teamList.length == 0")
                        td(colspan="9").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in teamList")
                        td
                          span {{ item.team_id }}
                        td
                          span {{ item.sport_type }}
                        td
                          span(:title="item.team_name") {{ item.team_name }}
                        td
                          span {{ item.sbo_map }}
                        td
                          span {{ item.ibc_map }}
                        td
                          span {{ item.prefer_id }}
                        td
                          span {{ item.link_id }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
          div(v-if="pageLvl == 'detail'")
            div(style="height: 650px;")
              div.row.mb-1
                div.col
                  SubmitButton(
                    :loading="loading"
                    icon="icon-arrow-left"
                    :text="$t('ui.back')"
                    type="button"
                    @click="backToMaster"
                    variant="secondary"
                    size="sm"
                    ).mb-1
              div.row.mb-1(v-if="teamInfo")
                div.col
                  b-form-group(:label="$t('ui.current_team')").mb-3
                    div.row.mb-1.animated.fadeIn
                      div.col
                        table.tablex(style="width: 100%;" v-columns-resizable)
                          thead
                            tr
                              th.sticky-position(width=100)
                                span {{ $t('ui.id') }}
                              th.sticky-position(width=80)
                                span {{ $tc('ui.sports', 1) }}
                              th.sticky-position
                                span {{ $t("ui.name") }}
                              th.sticky-position(width=100)
                                span {{ $t("ui.sbo") }}
                              th.sticky-position(width=100)
                                span {{ $t("ui.ibc") }}
                              th.sticky-position(width=60)
                                span {{ $t("ui.linked") }}
                              th.sticky-position(width=40).text-center
                                span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                          tbody.clusterize-content
                            tr
                              td
                                span {{ teamInfo.team_id }}
                              td
                                span {{ teamInfo.sport_type }}
                              td
                                span(:title="teamInfo.team_name") {{ teamInfo.team_name }}
                              td
                                span {{ teamInfo.sbo_map }}
                              td
                                span {{ teamInfo.ibc_map }}
                              td
                                span {{ teamInfo.link_id }}
                              td.text-center
                                span
                                  i(:class="{'fas fa-check text-info': teamInfo.mark_fetch, 'fas fa-times text-warning': !teamInfo.mark_fetch  }")
              div.row.mb-1
                div.col
                  div.row
                    div.col-md-6.clusterize.animated.fadeIn
                      div(v-if="sboTeamInfo")
                        b-form-group(:label="$t('ui.sbo_team')").mb-3
                          div.row.mb-1
                            div.col
                              table.tablex(v-columns-resizable)
                                thead
                                  tr
                                    th.sticky-position(width=100)
                                      span {{ $t('ui.id') }}
                                    th.sticky-position(width=80)
                                      span {{ $tc('ui.sports', 1) }}
                                    th.sticky-position
                                      span {{ $t("ui.name") }}
                                    th.sticky-position(width=80)
                                      span {{ $t("ui.sbo") }}
                                    th.sticky-position(width=80)
                                      span {{ $t("ui.ibc") }}
                                tbody.clusterize-content
                                  tr
                                    td
                                      span {{ sboTeamInfo.team_id }}
                                    td
                                      span {{ sboTeamInfo.sport_type }}
                                    td
                                      span(:title="sboTeamInfo.team_name") {{ sboTeamInfo.team_name }}
                                    td
                                      span {{ sboTeamInfo.sbo_map }}
                                    td
                                      span {{ sboTeamInfo.ibc_map }}
                      div(v-if="ibcTeamInfo")
                        b-form-group(:label="$t('ui.ibc_team')").mb-3
                          div.row.mb-1
                            div.col
                              table.tablex(v-columns-resizable)
                                thead
                                  tr
                                    th.sticky-position(width=100)
                                      span {{ $t('ui.id') }}
                                    th.sticky-position(width=80)
                                      span {{ $tc('ui.sports', 1) }}
                                    th.sticky-position
                                      span {{ $t("ui.name") }}
                                    th.sticky-position(width=80)
                                      span {{ $t("ui.sbo") }}
                                    th.sticky-position(width=80)
                                      span {{ $t("ui.ibc") }}
                                tbody.clusterize-content
                                  tr
                                    td
                                      span {{ ibcTeamInfo.team_id }}
                                    td
                                      span {{ ibcTeamInfo.sport_type }}
                                    td
                                      span(:title="ibcTeamInfo.team_name") {{ ibcTeamInfo.team_name }}
                                    td
                                      span {{ ibcTeamInfo.sbo_map }}
                                    td
                                      span {{ ibcTeamInfo.ibc_map }}
                    div.col-md-6.clusterize.animated.fadeIn.mt-3(v-if="sboTeamInfo || ibcTeamInfo")
                      div.row.mb-2
                        div.col-md-2
                          b-input-group(size="sm")
                            b-form-select(v-model="provider")
                              option(value="SBO") {{ $t('ui.sbo') }}
                              option(value="IBC") {{ $t('ui.ibc') }}
                            b-input(:value="filterUnteamListLength" readonly)
                        div.col-md-6
                          b-input-group(size="sm")
                            b-input-group-text(slot="prepend")
                              i.fas.fa-search
                            DebounceInput(required type="text" v-model="unteamSearch" :placeholder="$t('message.search_by_team_name')").mr-1
                            b-form-radio-group(
                              buttons
                              v-model="unteamFilterBy"
                              size="sm"
                              button-variant="outline-info"
                            )
                              b-form-radio(value="id") {{ $t("ui.id") }}
                              b-form-radio(value="name") {{ $t("ui.name") }}
                      div.row.mb-1
                        div.col-12.clusterize
                          div.clusterize-scroll(style="max-height: 450px;")
                            table.tablex(v-columns-resizable)
                              thead
                                tr
                                  th.sticky-position(width=100 @click="sortOrder('league_id', 'detail')")
                                    span {{ $t('ui.id') }}
                                    i(:class="changeSortKey('league_id', 'detail')")
                                  th.sticky-position(width=80 @click="sortOrder('sport_type', 'detail')")
                                    span {{ $tc('ui.sports', 1) }}
                                    i(:class="changeSortKey('sport_type', 'detail')")
                                  th.sticky-position(@click="sortOrder('team_name', 'detail')")
                                    span {{ $t("ui.name") }}
                                    i(:class="changeSortKey('team_name', 'detail')")
                                  th.sticky-position(width=80)
                                    span {{ $t("ui.sbo") }}
                                  th.sticky-position(width=80)
                                    span {{ $t("ui.ibc") }}
                              tbody.clusterize-content
                                tr(
                                  v-for="(item, index) in filterUnteamList"
                                  @click="rowSelect(item)"
                                  :class="{ 'selectedRow' : selectedRow(item) }"
                                  )
                                  td
                                    span {{ item.team_id }}
                                  td
                                    span {{ item.sport_type }}
                                  td
                                    span(:title="item.team_name") {{ item.team_name }}
                                  td
                                    span {{ item.sbo_map }}
                                  td
                                    span {{ item.ibc_map }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    teamInfo: null,
    sboTeamInfo: null,
    ibcTeamInfo: null,
    sportType: 1,
    sportList: [],
    teamList: [],
    sboTeamList: [],
    ibcTeamList: [],
    currentTeamPage: 1,
    teamTotalRow: 0,
    teamSearch: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    pageLvl: 'master',
    provider: 'SBO',
    masterSortKey: "team_name",
    masterSortType: "asc",
    detailSortKey: "team_name",
    detailSortType: "asc",
    unteamFilterBy: 'name',
    unteamSearch: "",
    unteamIdSelected: "",
    firstProvider: "SBO",
    secondProvider: "IBC",
    filter: false,
    linked: true,
    fetched: true,
    filterBy: "name"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    unteamList:
    {
      get() {
        if (this.provider.toLowerCase() == 'sbo') {
          return this.sboTeamList;
        }
        else if (this.provider.toLowerCase() == 'ibc') {
          return this.ibcTeamList;
        }
        return [];
      },
      set(value)
      {
        this.value = value
      }
    },
    filterUnteamListLength() {
      if (this.filterUnteamList) {
        return this.filterUnteamList.length;
      } else {
        return 0;
      }
    },
    filterUnteamList:
    {
      get() {
        return this.unteamList.filter(item => {
          if (this.unteamFilterBy == "name") return item.team_name.toLowerCase().indexOf(this.unteamSearch.toLowerCase()) > -1;
          else if (this.unteamFilterBy == "id") return item.team_id.toString().indexOf(this.unteamSearch.toLowerCase()) > -1;
        })
        .sort((a, b) => {
          if (this.detailSortType == 'asc')
            return a[this.detailSortKey] > b[this.detailSortKey] ? 1 : -1;
          else
            return a[this.detailSortKey] < b[this.detailSortKey] ? 1 : -1;
        });
      },
      set(value)
      {
        this.value = value
      }
    }
  },
  mounted: function() {
    this.getSportList();
  },
  methods: {
    sortOrder(key, type) {
      if (type == 'master') {
        if (this.masterSortKey == key)
          this.masterSortType = this.masterSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.masterSortKey = key;
          this.masterSortType = 'asc';
        }
      } else if (type == 'detail') {
        if (this.detailSortKey == key)
          this.detailSortType = this.detailSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.detailSortKey = key;
          this.detailSortType = 'asc';
        }
      }

    },
    changeSortKey(key, type) {
      if (type == 'master') {
        if (this.masterSortKey != key)
          return 'fas fa-sort';
        else if (this.masterSortKey == key && this.masterSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.masterSortKey == key && this.masterSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'detail') {
        if (this.detailSortKey != key)
          return 'fas fa-sort';
        else if (this.detailSortKey == key && this.detailSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.detailSortKey == key && this.detailSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapteam
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLinkedTeamList: function(isSearch) {
      this.pageLvl = "master";

      let url = config.remapTeamListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentTeamPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapteam,
        sport_id: this.sportType,
        mapped: true,
        map_from: this.firstProvider.toLowerCase(),
        map_to: this.secondProvider.toLowerCase(),
        page_number: this.currentTeamPage,
        page_size: this.getPageSize,
        sort_key: this.sortKey,
        sort_type: this.sortType
      };

      if (this.filter) {
        json.linked = this.linked;
        json.fetched = this.fetched;
      }

      if (this.filterBy == "id") {
        json.team_id = this.teamSearch;
      } else {
        json.team_name = this.teamSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.teamList = response.data.tbl_remap_team_list;
                this.teamTotalRow = this.teamList.length > 0 ? this.teamList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(item) {
      this.pageLvl = "detail";
      this.teamInfo = item;
      this.getProviderTeamList(item);
      this.getTeamList();
    },
    getProviderTeamList(item) {
      let url = config.providerTeamListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapteam,
        sbo_team: item.sbo_map,
        ibc_team: item.ibc_map
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.tbl_provider_team_list.Table.length > 0)
                  this.sboTeamInfo = response.data.tbl_provider_team_list.Table[0];

                if (response.data.tbl_provider_team_list.Table1.length > 0)
                  this.ibcTeamInfo = response.data.tbl_provider_team_list.Table1[0];

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTeamList() {
      let url = config.mapTeamListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapteam,
        sport_id: this.sportType,
        mapped: false,
        map_from: this.firstProvider.toLowerCase(),
        map_to: this.secondProvider.toLowerCase(),
        sort_key: this.sortKey,
        sort_type: this.sortType
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // Success
          this.loading = false;
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sboTeamList = [];
                this.ibcTeamList = [];
                this.sboTeamList = response.data.tbl_map_team_list.Table;
                this.ibcTeamList = response.data.tbl_map_team_list.Table1;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedRow: function(info) {
      if (this.unteamIdSelected == info.team_id) return true;

      return false;
    },
    rowSelect: function(teamInfo) {
      setTimeout(() => {
        this.unteamIdSelected = teamInfo.team_id;
      }, 1);
    },
    remapTeam: function(type, mapType) {
      this.$helpers
        .alert({
          title: this.$t("ui.remap_team"),
          text: this.$t("message.remap_team_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmRemapTeam(type, mapType);
          }
        });
    },
    confirmRemapTeam: function(type, mapType) {
      let url = "";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.remapteam,
        map_type: mapType
      };

      if (this.firstProvider.toLowerCase() == "sbo" && this.secondProvider.toLowerCase() == "ibc") {
        url = config.remapTeamSBOIBCUrl();
        if (mapType == 'self') {
            json.sbo_id = this.sboTeamInfo.team_id;
            json.ibc_id = this.ibcTeamInfo.team_id;
            json.self_map = type != 'first' ? 'ibc' : 'sbo';
        } else {
          if (this.provider.toLowerCase() == 'sbo') {
            json.sbo_id = this.unteamIdSelected;
            json.ibc_id = this.ibcTeamInfo.team_id;
            json.prefer_id = type != 'first' ? this.ibcTeamInfo.team_id : this.unteamIdSelected;
          }
          else if (this.provider.toLowerCase() == 'ibc') {
            json.sbo_id = this.sboTeamInfo.team_id;
            json.ibc_id = this.unteamIdSelected;
            json.prefer_id = type != 'first' ? this.unteamIdSelected : this.sboTeamInfo.team_id;
          }
        }
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {

                this.backToMaster();

                this.$snotify.success(this.$t("message.success"));
              } else {
                this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToMaster: function() {
      this.pageLvl = "master";
      // var this1 = this;
      // this.linkedMatchList.filter(function(info) {
      //   if (info.team_id == this1.teamInfo.team_id) {
      //     info.sbo_map = sbo;
      //     info.ibc_map = ibc;
      //   }
      // });
      this.unteamIdSelected = "";
      this.unteamList = [];
      this.unteamSearch = "";
      this.teamInfo = null;
      this.sboTeamInfo = null;
      this.ibcTeamInfo = null;
      this.provider = 'SBO';
      this.getLinkedTeamList();
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentTeamPage = 1;
      this.getLinkedTeamList();
    },
    changedPage: function(pageNo) {
      this.currentTeamPage = pageNo;
      this.getLinkedTeamList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>